/*eslint-disable */
import router from '../router/'
import infoApi from '@/api/index'
import { Message } from 'element-ui';

// ユーザーエージェントを判定してPCとSPを出しわけ
let ua = navigator.userAgent
// console.log(navigator);
let ispc = true
if (ua.indexOf('iPhone') > 0 ||
  ua.indexOf('iPod') > 0 ||
  (ua.indexOf('Android') > 0 && ua.indexOf('Mobile')) > 0 ||
  ua.indexOf('iPad') > 0 ||
  ua.indexOf('Android') > 0) {
  ispc = false
} else {
  ispc = true
}

const DEV = process.env.NODE_ENV === 'development'
const state = {
  current_offer: {},
  email: null,
  ispc: ispc,
  page: 'form',
  submitted: false,
  user_submitted: false,
  expired: false,
  code_error: false,
  loading: true,
}

const actions = {
  getRegistrationInfo({commit}) {
    // console.log(router.history.current.query.code);
    infoApi.getInfo(res => {
      if (!DEV) {
        setTimeout(function () {
          gtag('config', 'UA-59440032-5', {
            'page_title': '/',
            'page_path': '/',
            'client_id': res.offer_id
          });
        }, 0)
      }

      if (res === 'submitted') {
        commit('update', {'submitted': true})
        commit('update', {'loading': false})
      } else if (res === 'expired') {
        commit('update', {'expired': true})
        commit('update', {'loading': false})
      } else if (res === 'notavailable') {
        commit('update', {'code_error': true})
        commit('update', {'loading': false})
      } else if (res === 'nonexistent') {
        commit('update', {'code_error': true})
        commit('update', {'loading': false})
      } else {
        commit('update', {'current_offer': res})
        commit('update', {'code_error': false})
        commit('update', {'loading': false})
      }
    })
  },
  saveInfo({commit}, email) {
    commit('update', {'loading': true})
    infoApi.saveInfo(email, res => {
      commit('update', {'loading': false})
      if (res.data.error) {
        Message({
          message: 'メールアドレスを正しく入力してください',
          type: 'error'
        });
      } else {
        commit('update', {'user_submitted': true})
        commit('handle_page', 'thanks')
        router.push({path: "thanks"})
        if (!DEV) {
          setTimeout(function () {
            gtag("config", "UA-59440032-5", {
              page_title: "thanks",
              page_path: "/thanks",
              client_id: state.current_offer.offer_id
            });
          }, 0);
        }
      }
    })
  }
}

const mutations = {
  handle_page(state, res) {
    state.page = res
  },
  /**
   * 情報のアップデート処理
   * @param  {[string]}
   */
  update(state, obj) {
    for (let k in obj) {
      state[k] = obj[k]
    }
  }
}

const getters = {
  ispc(state) {
    return state.ispc
  },
  email(state) {
    return state.email
  },
  current_offer(state) {
    return state.current_offer
  },
  page(state) {
    return state.page
  },
  submitted(state) {
    return state.submitted
  },
  user_submitted(state) {
    return state.user_submitted
  },
  expired(state) {
    return state.expired
  },
  code_error(state) {
    return state.code_error
  },
  loading(state) {
    return state.loading
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/info.js